(() => {
  const STORAGE_KEY = 'armade-recent-products-v1';
  const MAX_RECENT = 8;

  const emit = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent('armade:catalog-action', {
      detail: { name, ...detail },
    }));
  };

  const safeParse = (value) => {
    try {
      return JSON.parse(value) || [];
    } catch (_error) {
      return [];
    }
  };

  const readRecent = () => {
    try {
      const value = safeParse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(value) ? value : [];
    } catch (_error) {
      return [];
    }
  };

  const safeProductUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      const allowedHosts = new Set([
        window.location.hostname,
        'armadeinmi.com',
        'www.armadeinmi.com',
        'armade-in-mi.myshopify.com',
      ]);
      if (!['http:', 'https:'].includes(url.protocol) || !allowedHosts.has(url.hostname)) return '';
      if (!url.pathname.startsWith('/products/')) return '';
      return url.href;
    } catch (_error) {
      return '';
    }
  };

  const safeImageUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      const isShopifyCdn = url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.net');
      const isStoreImage = ['armadeinmi.com', 'www.armadeinmi.com', window.location.hostname].includes(url.hostname);
      return ['http:', 'https:'].includes(url.protocol) && (isShopifyCdn || isStoreImage) ? url.href : '';
    } catch (_error) {
      return '';
    }
  };

  const writeRecent = (product) => {
    if (!product || !product.handle) return;
    const next = [product, ...readRecent().filter((item) => item.handle !== product.handle)].slice(0, MAX_RECENT);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (_error) {
      // Browsing can continue when storage is blocked or unavailable.
    }
  };

  const makeText = (tag, value, className) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = value || '';
    return node;
  };

  const renderRecent = (root) => {
    const shelf = root.querySelector('[data-armade-recently-viewed]');
    const holder = root.querySelector('[data-armade-recent-items]');
    if (!shelf || !holder) return;

    const recent = readRecent();
    if (!recent.length) {
      shelf.hidden = true;
      holder.replaceChildren();
      return;
    }

    const safeRecent = recent
      .map((product) => ({ ...product, url: safeProductUrl(product.url), image: safeImageUrl(product.image) }))
      .filter((product) => product.handle && product.title && product.url);

    if (!safeRecent.length) {
      shelf.hidden = true;
      holder.replaceChildren();
      return;
    }

    holder.replaceChildren(...safeRecent.slice(0, 4).map((product) => {
      const link = document.createElement('a');
      link.className = 'armade-market-recent-card';
      link.href = product.url;

      const copy = document.createElement('span');
      copy.append(
        makeText('strong', product.title),
        makeText('span', product.price),
        makeText('span', product.vendor),
      );
      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = product.title;
        image.loading = 'lazy';
        image.width = 160;
        image.height = 160;
        link.append(image);
      }
      link.append(copy);
      return link;
    }));
    shelf.hidden = false;
  };

  document.querySelectorAll('[data-armade-market-catalog]').forEach((root) => {
    renderRecent(root);

    const searchInput = root.querySelector('[data-js-search-input]');
    const searchForm = searchInput ? searchInput.closest('form') : null;
    const searchOverlay = searchInput && searchInput.dataset.jsFocusOverlay
      ? document.getElementById(searchInput.dataset.jsFocusOverlay)
      : null;
    const closeSearchOverlay = () => {
      if (searchOverlay) searchOverlay.classList.remove('active');
    };

    if (searchInput && searchForm && searchOverlay) {
      searchOverlay.addEventListener('click', closeSearchOverlay);
      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeSearchOverlay();
          searchInput.focus();
        }
      });
      searchForm.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!searchForm.contains(document.activeElement)) closeSearchOverlay();
        });
      });
    }

    root.addEventListener('click', (event) => {
      const scrollButton = event.target.closest('[data-armade-scroll]');
      if (scrollButton) {
        const target = document.getElementById(scrollButton.getAttribute('aria-controls'));
        if (target) {
          const direction = Number(scrollButton.dataset.armadeScroll || 1);
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollBy({ left: direction * Math.max(280, target.clientWidth * 0.78), behavior: reducedMotion ? 'auto' : 'smooth' });
          emit('shelf_scrolled', { shelf: target.dataset.shelfName || target.id, direction });
        }
        return;
      }

      const product = event.target.closest('[data-armade-market-product]');
      const productLink = event.target.closest('a[href*="/products/"]');
      if (product && productLink) {
        writeRecent({
          handle: product.dataset.productHandle,
          title: product.dataset.productTitle,
          vendor: product.dataset.productVendor,
          price: product.dataset.productPrice,
          image: product.dataset.productImage,
          url: product.dataset.productUrl,
        });
        emit('product_clicked', { shelf: product.dataset.shelfName, handle: product.dataset.productHandle });
      }

      const action = event.target.closest('[data-armade-action]');
      if (action) {
        emit(action.dataset.armadeAction, { destination: action.getAttribute('href') });
      }
    });

    root.addEventListener('submit', (event) => {
      if (event.target.matches('[data-armade-market-search]')) {
        const input = event.target.querySelector('input[name="q"]');
        const query = input ? input.value.trim() : '';
        emit('search_submitted', { query });
        event.preventDefault();

        if (!query) {
          if (input) input.focus();
          return;
        }

        const destination = new URL(event.target.action || '/search', window.location.origin);
        destination.searchParams.set('q', query);
        window.location.assign(destination.toString());
      }
    });
  });
})();
